import { createContext, useContext, useState, useEffect } from "react";
import { strings } from "@/lib/i18n";

const AppContext = createContext(null);

export const AppProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("dds_lang") || "en");
  const [token, setToken] = useState(() => localStorage.getItem("dds_token") || "");

  useEffect(() => {
    localStorage.setItem("dds_lang", lang);
  }, [lang]);

  useEffect(() => {
    if (token) localStorage.setItem("dds_token", token);
    else localStorage.removeItem("dds_token");
  }, [token]);

  const t = (key) => strings[lang]?.[key] ?? strings.en[key] ?? key;

  return (
    <AppContext.Provider value={{ lang, setLang, t, token, setToken }}>
      {children}
    </AppContext.Provider>
  );
};

export const useApp = () => {
  const ctx = useContext(AppContext);
  if (!ctx) throw new Error("useApp must be inside AppProvider");
  return ctx;
};
